import {Selection} from './Editor';
import {
  IconDefinition,
  faBold,
  faItalic,
  faStrikethrough,
  faLink,
  faGripLines,
  faQuoteRight,
} from '@fortawesome/free-solid-svg-icons';

interface Tool {
  name: string;
  icon: IconDefinition;
  command: EditorCommand;
}

interface SelectionParts {
  start: string;
  selected: string;
  end: string;
}

export type EditorCommand = (content: string, selection: Selection) => [string, Selection];

const expandSelection = (content: string, selection: Selection, start: string, end?: string): Selection => {
  console.log(`Expand ${start} ${end}`);
  return selection;
};

const splitSelection = (content: string, selection: Selection): SelectionParts => {
  let start = '';
  let selected = '';
  let end = '';
  if (selection.start > 0) {
    start = content.slice(0, selection.start);
  }

  if (selection.end < content.length) {
    end = content.slice(selection.end);
  }

  if (selection.start !== selection.end) {
    selected = content.slice(selection.start, selection.end);
  }

  return {
    start,
    selected,
    end,
  };
};

const boldCommand = (content: string, selection: Selection): [string, Selection] => {
  selection = expandSelection(content, selection, '**', '**');

  const {start, selected, end} = splitSelection(content, selection);
  content = `${start}**${selected}**${end}`;
  selection = {
    start: selection.start + 2,
    end: selection.end + 2,
  };

  return [content, selection];
};

const italicCommand = (content: string, selection: Selection): [string, Selection] => {
  selection = expandSelection(content, selection, '_', '_');

  const {start, selected, end} = splitSelection(content, selection);
  content = `${start}_${selected}_${end}`;
  selection = {
    start: selection.start + 1,
    end: selection.end + 1,
  };

  return [content, selection];
};

const strikeThroughCommand = (content: string, selection: Selection): [string, Selection] => {
  selection = expandSelection(content, selection, '~~', '~~');

  const {start, selected, end} = splitSelection(content, selection);
  content = `${start}~~${selected}~~${end}`;
  selection = {
    start: selection.start + 2,
    end: selection.end + 2,
  };

  return [content, selection];
};

const horizontalRuleCommand = (content: string, selection: Selection): [string, Selection] => {
  const {start, end} = splitSelection(content, selection);
  content = `${start}\n---\n${end}`;
  selection = {
    start: selection.start + 4,
    end: selection.end + 4,
  };

  return [content, selection];
};

const quoteCommand = (content: string, selection: Selection): [string, Selection] => {
  const {start, selected, end} = splitSelection(content, selection);
  content = `${start}> ${selected}${end}`;
  selection = {
    start: selection.start + 2,
    end: selection.end + 2,
  };

  return [content, selection];
};

export const imageCommand = (content: string, selection: Selection, url: string): [string, Selection] => {
  const {start, end} = splitSelection(content, selection);
  content = `${start}![Image](${url})${end}`;
  selection = {
    start: selection.start + url.length,
    end: selection.end + url.length,
  };

  return [content, selection];
};

export const tools: Tool[] = [
  {
    name: 'Bold',
    icon: faBold,
    command: boldCommand,
  },
  {
    name: 'Italic',
    icon: faItalic,
    command: italicCommand,
  },
  {
    name: 'Strike Through',
    icon: faStrikethrough,
    command: strikeThroughCommand,
  },
  {
    name: 'Quote',
    icon: faQuoteRight,
    command: quoteCommand,
  },
  {
    name: 'Horizontal Rule',
    icon: faGripLines,
    command: horizontalRuleCommand,
  },
  {
    name: 'Link',
    icon: faLink,
    command: italicCommand,
  },
];
